import React from 'react';

import ImportImages from '@src/importImages';
import Css from './Mobile.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';

const Logos = ImportImages('/footer/logos.jpg');

const mobile = props => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      {!props.hideNav && (
        <img
          src={Logos}
          className={'center-block img-fluid p-3'}
          alt={'Logos'}
        />
      )}
      <div className={Css['nav-container']}>
        <div className={Css.copyright + ' text-center pb-3 lakes-medium'}>
          <FontAwesomeIcon icon={['far', 'copyright']} />
          &nbsp; Copyright {currentYear} JetSuite Air
        </div>
        {!props.hideNav && (
          <Nav className={'d-block lakes-medium'}>
            <NavItem>
              <Link to="/contact-us" className={'nav-link'}>
                Contact Us
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/careers" className={'nav-link'}>
                Careers
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/news" className={'nav-link'}>
                In the news
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/faq" className={'nav-link'}>
                Faq
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/partners" className={'nav-link'}>
                Partners
              </Link>
            </NavItem>
            <NavItem>
              <a
                href="https://account.jetsuite.com/suitedeal/"
                className={'nav-link'}
              >
                Suitedeals
              </a>
            </NavItem>
            <NavItem>
              <NavLink href="https://www.jsx.com" target={'_blank'}>
                JSX
              </NavLink>
            </NavItem>
            <NavItem>
              <Link to="/leadership" className={'nav-link'}>
                Leadership
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/legal" className={'nav-link'}>
                Legal
              </Link>
            </NavItem>
          </Nav>
        )}

        {!props.hideNav && (
          <Nav className={'pt-4 pb-3 justify-content-center'}>
            <NavItem>
              <NavLink
                href="https://www.instagram.com/jetsuite/"
                target={'_blank'}
                className={'pl-2 pr-2'}
              >
                <FontAwesomeIcon icon={['fab', 'instagram']} />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://www.facebook.com/JetSuiteAir/"
                target={'_blank'}
                className={'pl-2 pr-2'}
              >
                <FontAwesomeIcon icon={['fab', 'facebook-square']} />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://www.linkedin.com/company/jetsuite/"
                target={'_blank'}
                className={'pl-2 pr-2'}
              >
                <FontAwesomeIcon icon={['fab', 'linkedin']} />
              </NavLink>
            </NavItem>
          </Nav>
        )}

        {!props.hideNav && (
          <div className={Css.explanations + ' text-center pb-4 asap-regular'}>
            Phenom 100 and Phenom 300 flights operated by
            <br />
            Superior Air charter dba JetSuite Air. FAA Air Carrier Certificate
            9SUA667M. Legacy
            <br />
            650 and E135 flights operated by Delux Public Charter dba JetSuiteX
            Air, FAA Air
            <br />
            Carrier Certificate 4DPA97O.
          </div>
        )}
      </div>
    </footer>
  );
};

export default mobile;



// WEBPACK FOOTER //
// ./src/components/Footer/Mobile/Mobile.js